import React, {Component} from 'react'

import _ from 'i18n';

export default class SidePageHeader extends Component {

  render() {
    const {app, subHeader, tabContainer, organization} = this.props;

    return <div className={`side-page-header ${tabContainer ? "absolute" : ""}`}>
      <div className="side-page-header__info">
        <p> {_(app)} </p>
        <img src="/img/icons/Arrow.svg"/>
        <p className="sub-header"> {subHeader} </p>
        {organization ? <div className="flex"> <img src="/img/icons/Arrow.svg"/>
          <p className="sub-header"> {organization} </p> </div> : null}

      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/common/SidePageHeader.js